export const listingClassification = [
  { value: '上場', label: '上場' },
  { value: '非上場', label: '非上場' }
]

export const reportingCompanyCategory = [
  { value: '提出会社', label: '提出会社' },
  { value: '子会社', label: '子会社' },
  { value: '特定子会社', label: '特定子会社' },
  { value: '持分法適用会社', label: '持分法適用会社' },
  { value: '関連会社', label: '関連会社' },
  { value: 'その他子会社', label: 'その他子会社' }
]

export const marketSegment = [
  { value: '東証プライム', label: '東証プライム' },
  { value: '東証スタンダード', label: '東証スタンダード' },
  { value: '東証グロース', label: '東証グロース' },
  { value: '札幌', label: '札幌' },
  { value: '名古屋', label: '名古屋' },
  { value: '福岡', label: '福岡' }
]
